<router-outlet (activate)="changeOfRoutes()"></router-outlet>
<app-footer></app-footer>